module.exports = __webpack_public_path__ + "img/coursesPhoneCode.20eba40c.jpg";